import { Container } from "./styles";

export default function Back2(){
    return(
        <Container>
            <h2>IDIOMAS</h2>
            <div>
                <h3>Português | Nativo</h3>
                <h3 id="mobileSpace">Inglês | Fluente</h3>
                <h3>Espanhol | Básico</h3>
            </div>
        </Container>
    )
}